<template>
  <div v-if="itemLocations && itemLocations.length">
    <ul class="unordered-list pl-0 mb-1">
      <li v-for="itemLocation in itemLocations.slice(0,5)" :key="`${itemLocation.uuid}`">
        {{ itemLocation.item_location.name | truncate(50)}} {{(itemLocation.container_type ? '- ' + itemLocation.container_type: '' ) | truncate(52)}}
      </li>
    </ul>
    <div v-if="itemLocations.length > 5">
    <span class="hover-cursor hover-underline"
          @click="onShowMoreClick"> {{ $t("+{n} more", {n: itemLocations.length - 5}) }} </span>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
const {mapActions} = createNamespacedHelpers('receipts');

export default {
  name: "ReceiptItemLocation",
  props: {
    itemLocations: {
      type: Array|null,
      required: true
    }
  },
  methods: {
    ...mapActions(['showReceiptItemLocationModal']),
    onShowMoreClick() {
      this.showReceiptItemLocationModal({
        itemLocations: this.itemLocations,
      })
    }
  }
}
</script>

<style scoped>
.hover-underline {
  &:hover {
    text-decoration: underline;
  }
}
.hover-cursor{
  cursor: pointer;
}
.unordered-list {
  list-style-type: none;
}

</style>
